// @ utilities
const { toCamelCase } = require('utilities/stringHelper');
const { composeIban } = require('utilities/ibanHelper');

const findAccountName = (immAccounts, immAssociatedAccount) => {
    const iban = composeIban({
        codbban: immAssociatedAccount.get('codbban'),
        digitodecontrol: immAssociatedAccount.get('controlDigit'),
        pais: immAssociatedAccount.get('country')
    });

    const immAccount = immAccounts.get('byId').find(immCurrentAccount => {
        return immCurrentAccount.get('iban') === iban;
    });

    return immAccount ? immAccount.get('aliasTentative') || immAccount.get('alias') || toCamelCase(immAccount.get('accountType')) : '';
};

const getFormattedAccountNumber = immAssociatedAccount => {
    const accountNumber = immAssociatedAccount.get('codbban');

    if (!accountNumber) {
        return '';
    }

    return `${accountNumber.substr(0, 4)} ${accountNumber.substr(4, 4)} ${accountNumber.substr(8, 2)} ${accountNumber.substr(10)}`;
};

module.exports = {
    findAccountName,
    getFormattedAccountNumber
};
